import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactDOM from 'react-dom';
import { loadableReady } from '@loadable/component';
import { getCookie } from '@guardian/libs';
import { getOphanRecordFunction } from '../browser/ophan/ophan';
import { tests } from '../experiments/ab-tests';
import { App } from './App';
import { WithABProvider } from './WithABProvider';
export const BootReact = ({ CAPI }) => {
    const mvtId = Number((CAPI.config.isDev &&
        getCookie({ name: 'GU_mvt_id_local', shouldMemoize: true })) || // Simplify localhost testing by creating a different mvt id
        getCookie({ name: 'GU_mvt_id', shouldMemoize: true }));
    if (!mvtId) {
        // 0 is default and falsy here
        // eslint-disable-next-line no-console
        console.log('There is no MVT ID set, see BootReact.tsx');
    }
    const ophanRecord = getOphanRecordFunction();
    loadableReady(() => {
        ReactDOM.render(_jsx(WithABProvider, Object.assign({ arrayOfTestObjects: tests, abTestSwitches: CAPI.config.switches, pageIsSensitive: CAPI.config.isSensitive, mvtId: mvtId, ophanRecord: ophanRecord }, { children: _jsx(App, { CAPI: CAPI, ophanRecord: ophanRecord }, void 0) }), void 0), document.getElementById('react-root'));
    }).catch((e) => console.error(`BootReact @loadable/component - error: ${e}`));
};
